import { KgInsightThemeType } from '@api/api/kg-insights';
import { useTranslation } from 'react-i18next';

export interface ThemeSubtitleProps {
  type?: KgInsightThemeType;
}

export const ThemeSubtitle = ({ type }: ThemeSubtitleProps) => {
  const { t } = useTranslation('common');
  return t(`common:themeTypes.${type ?? 'default'}`);
};
